export default "__VITE_ASSET__Dwn63O2X__"